import { call, put } from 'redux-saga/effects';
import axios from '../../axiosConfig';

import {
  GET_USER_FOUND,
  GET_USER_NOT_FOUND,
  LOGOUT_SUCCESS,
} from '../Actions/AuthAction';
import { TOAST_SHOW } from '../Actions/ToastAction';


interface ILogin {
  payload: {
    email: string;
    password: string;
    credential: string,
  };
  isRefreshUserConfig:boolean,
}

export function* LoginSaga(action: ILogin): unknown {

  try {
    const response = yield call(axios.get, 'login-event');
    // console.log(response.data)
    if (response?.status === 200) {
      yield put({
        type: GET_USER_FOUND,
        payload: action.payload,
        userRole: response?.data?.roles,
        cjsc_ip:response?.data?.cjsc_ip,
        cjsc_fifo:response?.data?.cjsc_fifo,
        cjsc_multi_ipnoid:response?.data?.cjsc_multi_ipnoid,
        cjsc_multi_ipid:response?.data?.cjsc_multi_ipid,
        cjsc_infinite_fifo:response?.data?.cjsc_infinite_fifo,
        subUsers:response?.data?.subUsers,
        cjsc_id:response?.data?.cjsc_id,
        cjsc_id_ip:response?.data?.cjsc_id_ip,
        cjsc_ip_without_id:response?.data?.cjsc_ip_without_id,
        cjscIds:response?.data?.cjscIds,
        cjsc_script:response?.data?.cjsc_script,
        cjsc_ignoreHttp:response?.data.cjsc_ignoreHttp,
        show_cjsc_ignoreHttp:response?.data?.show_cjsc_ignoreHttp,
        panda:response?.data?.panda,
        monitor:response?.data?.monitor,
        cjsc_user_agent:response?.data?.cjsc_user_agent,
        concat:response?.data?.concat,
        controlium_type:response?.data?.controlium_type,
        tenant_name:response?.data?.tenant_name,
        show_hash:response?.data?.show_hash,
        logo_folder:response?.data?.logo_folder,
        line_item_id:response?.data?.line_item_id,
        line_item_id_demo:response?.data?.line_item_id_demo,
        line_item_without_id:response?.data?.line_item_without_id,
        line_item_without_id_demo:response?.data?.line_item_without_id_demo,
        countries:response?.data?.countries,
        countries_type:response?.data?.countries_type,
        browsers:response?.data?.browsers,
        browsers_type:response?.data?.browsers_type,
        oss:response?.data?.oss,
        oss_type:response?.data?.oss_type,
        ccu_campaigns:response?.data?.ccu_campaigns,
        truncated_ips:response?.data?.truncated_ips,
        multi_campaign:response?.data?.multi_campaign,
        allow_pause:response?.data?.allow_pause,
        allow_edit:response?.data?.allow_edit,
        audience_idfa:response?.data?.audience_idfa,
        audience_ad_id:response?.data?.audience_ad_id,
        audience_ip_address:response?.data?.audience_ip_address,
        audience_web_id:response?.data?.audience_web_id,
        disrupt_opsec_v2:response?.data?.disrupt_opsec_v2,
        id:response?.data?._id,
        eyield:response?.data?.eyield,
        tyield:response?.data?.tyield,
        sync_user:response?.data?.sync_user,
        sync_domain:response?.data?.sync_domain,
        ah_user:response?.data?.ah_user,
        cc_infinite_fifo:response?.data?.cc_infinite_fifo,

      });
      if(action?.isRefreshUserConfig){
      }else{ 
        yield put({
          type: TOAST_SHOW,
          payload: { message: 'Login Successfully!' , severity: 'Success', show: true },
        });
      }
    }

  } catch (e: any) {
    if (e.response.status === 500) {
      if (e.response.data.message) {
        yield put({
          type: TOAST_SHOW,
          payload: { message: e.response.data.message, severity: 'Danger', show: true },
        });
      }
    } else {
      yield put({
        type: TOAST_SHOW,
        payload: { message: 'Something Went wrong please try again', severity: 'Danger', show: true },
      });
    }

    yield put({ type: GET_USER_NOT_FOUND });
  }
}

export function* LogoutSaga(): unknown {
  try {
    // your api call here
    const response = yield call(axios.get, 'logout-event');

    if (response?.status === 200) {
      yield put({ type: LOGOUT_SUCCESS });
    }

  } catch (e) {
    yield put({
      type: TOAST_SHOW,
      payload: {
        message: 'Something Went wrong please try again',
        severity: 'Danger',
        show: true
      },
    });
  }
}
